"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var react_router_dom_1 = require("react-router-dom");
var youwell_common_1 = require("../../youwell-common");
var components_1 = require("../../youwell-common/components");
var LoadCurrentProgram_1 = __importDefault(require("./components/LoadCurrentProgram"));
var constants_1 = require("../../youwell-common/constants");
var UserStore = __importStar(require("../../app/store/UserStore"));
var AuthStore = __importStar(require("../../app/store/AuthStore"));
var Index_1 = __importDefault(require("../pages/Index"));
var Index_2 = __importDefault(require("../program/Index"));
var MessageList_1 = __importDefault(require("../messages/MessageList"));
var Videochat_1 = __importDefault(require("../videochat/Videochat"));
var Profile_1 = __importStar(require("../home/Profile"));
var Dashboard_1 = __importDefault(require("./Dashboard"));
var Consent_1 = __importDefault(require("../pages/Consent"));
var urls_1 = __importDefault(require("../../app/urls"));
var LoadCurrentProgramResponses_1 = __importDefault(require("./components/LoadCurrentProgramResponses"));
var LoadProfileData_1 = __importDefault(require("./components/LoadProfileData"));
var objectUtils_1 = require("../../youwell-common/objectUtils");
var constants_2 = require("../../common/constants");
var components_2 = require("../../common/components");
var taskUtils_1 = require("../../common/taskUtils");
var store_1 = require("../../app/store");
var USER_IDLE_TIMEOUT_IN_MINUTES = 30;
var POLLING_INTERVAL_IN_MINUTES = 5;
var consentUrl = "".concat(urls_1.default.inside.program, "/").concat(constants_2.patientProgramElementGroups.consent);
var Index = function () {
    var dispatch = (0, store_1.useYouwellDispatch)();
    var clientConfig = (0, store_1.useYouwellSelector)(function (state) { return state.auth.clientConfig; });
    var profileData = (0, store_1.useYouwellSelector)(function (state) { return state.auth.profileData; });
    var hasUnansweredConsents = (0, store_1.useYouwellSelector)(function (state) { return state.auth.hasUnansweredConsents; });
    var unAnsweredConsentIndex = (0, store_1.useYouwellSelector)(function (state) { return (state.programStore.currentProgram && (0, objectUtils_1.hasValue)(state.programStore.currentProgram.unAnsweredConsentIndex)
        ? state.programStore.currentProgram.unAnsweredConsentIndex : -1); });
    var currentProgram = (0, store_1.useYouwellSelector)(function (state) { return state.programStore.currentProgram; });
    var logoutOnIdle = function () {
        dispatch(AuthStore.actionCreators.logout(constants_1.logoutReasons.idleTimeout));
    };
    var getUserState = function () {
        dispatch(UserStore.actionCreators.getUserState());
    };
    var patientDataMissing = clientConfig.appSetup.patient.checkMissingData && (0, Profile_1.hasMissingData)(profileData, clientConfig);
    var showPrePage = patientDataMissing || hasUnansweredConsents || unAnsweredConsentIndex > -1;
    var sessionLifetime = youwell_common_1.Auth.getSessionLifetime();
    var getInternalLink = function (link) {
        if (!(link === null || link === void 0 ? void 0 : link.url))
            return null;
        if (link.url.startsWith('page:')) {
            var pageId = link.url.substring(5);
            return urls_1.default.inside[pageId] || urls_1.default.inside.pages[pageId];
        }
        return (0, taskUtils_1.getProgramContentLink)(link, currentProgram);
    };
    var renderPrePage = function () {
        if (hasUnansweredConsents) {
            return (React.createElement(react_router_dom_1.Switch, null,
                React.createElement(react_router_dom_1.Route, { path: "".concat(urls_1.default.inside.pages.consent, "/:consentId?"), component: Consent_1.default }),
                React.createElement(react_router_dom_1.Route, { render: function () { return (React.createElement(react_router_dom_1.Redirect, { to: { pathname: urls_1.default.inside.pages.consent } })); } })));
        }
        if (unAnsweredConsentIndex > -1) {
            return (React.createElement(react_router_dom_1.Switch, null,
                React.createElement(react_router_dom_1.Route, { path: consentUrl, component: Index_2.default }),
                React.createElement(react_router_dom_1.Route, { render: function () { return (React.createElement(react_router_dom_1.Redirect, { to: { pathname: "".concat(consentUrl, "/").concat(unAnsweredConsentIndex, "/").concat(urls_1.default.inside.parts.resumeLatest) } })); } })));
        }
        if (patientDataMissing) {
            return (React.createElement(Profile_1.default, null));
        }
        return null;
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(components_1.ErrorBoundary, { id: "Inside_Top" },
            React.createElement(components_2.PageTitle, null),
            sessionLifetime > 0 && (React.createElement(components_1.IdleTimer, { timeoutInMinutes: USER_IDLE_TIMEOUT_IN_MINUTES, onIdle: logoutOnIdle, hasInactivityAlert: true })),
            clientConfig.appSetup.patient.pollState && (React.createElement(components_1.PollData, { dataCall: getUserState, pollingIntervalInMinutes: POLLING_INTERVAL_IN_MINUTES }))),
        React.createElement(components_1.ErrorBoundary, { id: "Inside_Loading" },
            React.createElement(LoadProfileData_1.default, null),
            React.createElement(LoadCurrentProgram_1.default, null),
            React.createElement(LoadCurrentProgramResponses_1.default, null),
            React.createElement(components_2.InternalLinkLoader, { linkUrlFunction: function (link) { return getInternalLink(link); } }),
            React.createElement(components_2.ContentVariableLoader, { currentProgram: currentProgram, patientData: profileData })),
        React.createElement(components_2.Layout, { hideHeaderLinks: showPrePage, hideMenu: showPrePage }, renderPrePage() || (React.createElement(react_router_dom_1.Switch, null,
            React.createElement(react_router_dom_1.Route, { exact: true, path: urls_1.default.inside.home, component: Dashboard_1.default }),
            React.createElement(react_router_dom_1.Route, { path: urls_1.default.inside.profile, component: Profile_1.default }),
            React.createElement(react_router_dom_1.Route, { path: urls_1.default.inside.chat, component: MessageList_1.default }),
            React.createElement(react_router_dom_1.Route, { path: urls_1.default.inside.videochat, component: Videochat_1.default }),
            React.createElement(react_router_dom_1.Route, { path: urls_1.default.inside.program, component: Index_2.default }),
            React.createElement(react_router_dom_1.Route, { path: urls_1.default.inside.pages.home, component: Index_1.default }),
            React.createElement(react_router_dom_1.Route, { component: Dashboard_1.default }))))));
};
exports.default = Index;
